export class Constants {
  static RAD_30 = Math.PI / 6
  static RAD_90 = Math.PI / 2
  static RAD_135 = (Math.PI / 4) * 3
  static RAD_360 = Math.PI * 2
  static PHI = (1 + Math.sqrt(5)) / 2
}
